// Smart Daara - Payment Cancel Page
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { Card, CardContent } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  const { user } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <Card className="max-w-md w-full border-0 shadow-lg">
        <CardContent className="p-8 text-center">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-amber-100 flex items-center justify-center">
              <XCircle className="w-10 h-10 text-amber-600" />
            </div>
          </div>
          <h1 className="text-2xl font-outfit font-bold text-slate-900 mb-2">
            {language === 'fr' ? 'Paiement annulé' : 'Payment cancelled'}
          </h1>
          <p className="text-slate-500 mb-6">
            {language === 'fr' 
              ? 'Vous avez annulé le paiement. Aucun montant n\'a été débité.'
              : 'You have cancelled the payment. No amount has been charged.'
            }
          </p>
          <div className="space-y-3">
            <Button 
              className="bg-emerald-700 hover:bg-emerald-800 w-full"
              onClick={() => navigate('/school/subscription')}
            >
              {language === 'fr' ? 'Réessayer le paiement' : 'Retry Payment'}
            </Button>
            <Button 
              variant="outline"
              className="w-full"
              onClick={() => navigate(user?.role === 'super_admin' ? '/admin' : '/school')}
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              {language === 'fr' ? 'Retour au tableau de bord' : 'Back to Dashboard'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
